:host {
  max-width: 100%;
  display: block;
  margin-bottom: css-var(components-mb);

  @include cms-base-font;
}

.headline-wrapper {
  margin-bottom: 1.5rem;
}

.article-image-wrapper {
  margin-bottom: 0.75rem;
}

.cms-article-slider-headline {
  font-size: calc(1.4167rem + 1.111vw);
  text-align: center;

  @include headline-base-font;
}

@keyframes splide-loading {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(1turn);
  }
}

.splide__track--draggable {
  user-select: none;
}

.splide__sr {
  display: none;
}

.splide__container {
  box-sizing: border-box;
  position: relative;
}

.splide__list {
  backface-visibility: hidden;
  display: flexbox;
  display: flex;
  height: 100%;
  margin: 0;
  padding: 0;
}

.splide.is-initialized:not(.is-active) .splide__list {
  display: block;
}

.splide {
  position: relative;
  visibility: hidden;
  margin: 0 auto;
  width: 100%;
}

.splide.is-initialized,
.splide.is-rendered {
  visibility: visible;
}

.splide__slide {
  backface-visibility: hidden;
  box-sizing: border-box;
  flex-shrink: 0;
  list-style-type: none;
  margin: 0;
  position: relative;
}

.splide__slide img {
  vertical-align: bottom;
}

.splide__track {
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.splide__arrow {
  background: transparent;
  @include generateBorder('006', solid, theme-border-color);

  height: 2.375rem;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 2.375rem;
  z-index: 1;
  cursor: pointer;
  display: none;
  justify-content: center;
  align-items: center;
  border-radius: css-var(border-radius-025);
  text-decoration: none;

  path {
    fill: css-var(theme-svg-color);
  }
}

.splide__arrow:hover {
  background-color: rgb(0 0 0 / 5%);
}

.splide__arrow[disabled],
.splide__arrow.disabled {
  pointer-events: none;
  opacity: 0.4;
}

.splide__arrow--prev {
  left: -50px;
}

.splide__arrow--next {
  right: -50px;
}

.article-slider-cta {
  @include override-css-var(theme-text-color, var(--cms-dark-grey-dark));

  color: css-var(theme-text-color);
  text-decoration: none;
}

.article-slider-list {
  @include override-css-var(theme-background-color, var(--cms-white));

  background-color: css-var(theme-background-color);
  width: calc(90vw / 1.5);
  @include generateBorder('006', solid, theme-border-color);

  padding: 0.75rem;
}

.splide__slide__container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

@include media-width($breakpoint-sm) {
  .article-slider-list {
    width: calc(80vw / 2.5);
  }
}

@include media-width($breakpoint-md) {
  .splide__arrow {
    display: flex;
  }

  .splide {
    width: calc(100vw - 148px);
  }

  .article-slider-list {
    width: calc(85vw / 3.5);
  }
}

@include media-width($breakpoint-xl) {
  .article-slider-list {
    width: calc(1128px / 4.5);
  }

  .cms-article-slider-headline {
    font-size: 2.52rem;
  }

  .splide {
    max-width: 68.125rem;
  }
}
